export const SN_UTIL = 'util'
export const UTIL_CONFIG_FACILITES_UPDATED = SN_UTIL + '/CONFIG_FACILITIES_UPDATED'
export const UTIL_APPLIED_FILTERS_UPDATED = SN_UTIL + '/APPLIED_FILTERS_UPDATED'
export const UTIL_APPLIED_FILTERS_OPERATOR_UPDATED = SN_UTIL + '/APPLIED_FILTERS_OPERATOR_UPDATED'
export const UTIL_CLEARED = SN_UTIL + '/CLEARED'
export const UTIL_APPLIED_FILTERS_CLEARED = SN_UTIL + '/APPLIED_FILTERS_CLEARED'
export const UTIL_APPLIED_FILTERS_OPERATOR_CLEARED = SN_UTIL + '/APPLIED_FILTERS_OPERATOR_CLEARED'
export const UTIL_FACILITY_GROUPS_UPDATED = SN_UTIL + '/FACILITY_GROUPS_UPDATED'
export const UTIL_FACILITY_LIST_UPDATED = SN_UTIL + '/FACILITY_LIST_UPDATED'
export const UTIL_SELECTED_SEGMENT_UPDATED = SN_UTIL + '/SELECTED_SEGMENT_UPDATED'
export const UTIL_PICKUP_GROUPS_UPDATED = SN_UTIL + '/PICKUP_GROUPS_UPDATED'
export const UTIL_PICKUP_GROUP_FACILITIES = SN_UTIL + '/PICKUP_GROUP_FACILITIES_UPDATED'
export const UTIL_FACET_OPTIONS_UPDATED = SN_UTIL + '/FACET_OPTIONS_UPDATED'